<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑组织' : '新增组织'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :model="selfData" :rules="rules" label-width="100px">
        <el-form-item label="所属分类:">
          <el-input v-model="categoryName" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="上级组织:">
          <el-input v-model="selfData.parent_name" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="组织层级:">
          <el-input v-model="selfData.level" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item v-if="false" label="组织类型:" prop="lei_mu_lei_xing">
          <el-select
            v-if="selfData.level < 2"
            v-model="selfData.lei_mu_lei_xing"
            size="mini"
            style="width: 250px"
            clearable
          >
            <el-option
              v-for="(item, index) in categoryTypeList"
              class="flex flex-x-between"
              :key="index"
              :label="item.key"
              :value="item.val"
            />
          </el-select>
          <el-input
            v-else
            v-model="selfData.lei_mu_lei_xing"
            size="mini"
            style="width: 250px"
            disabled
          />
        </el-form-item>
        <el-form-item label="组织名称:" prop="name">
          <el-input v-model="selfData.name" size="mini" style="width: 250px" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        name: [{ required: true, message: '请输入组织' }],
        lei_mu_lei_xing: [{ required: true, message: '请选择组织类型' }]
      },
      categoryTypeList: [
        {
          key: '原料',
          val: '原料'
        },
        {
          key: '零件',
          val: '零件'
        },
        {
          key: '组装',
          val: '组装'
        },
        {
          key: '加工',
          val: '加工'
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/columnData/saveOrUpdate',
            data: {
              ...this.selfData,
              type: 'OA'
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
